import React, { memo, useEffect, useState } from "react";
import Loader from "../popups/Loading";

import "../report/report.css";
import "./Patient.css";
import Emp_data_pic from "../../assets/images/Emp_data_pic.png";
import { useSelector } from "react-redux";
import { Button, Card, Col, Form, Image, Modal, Row } from "react-bootstrap";
import CreateGroupClients from "../popups/CreateGroupClients";
import { AiOutlineSearch } from "react-icons/ai";
import { Popup } from "semantic-ui-react";
import GetStartedPopup from "../popups/GetStartedPopup";
import { useLocation, useHistory } from "react-router-dom";
import { getHighlightStyles } from "../setting/HighlightConstants.js";
import { AutoComplete, DatePicker, Select } from "antd";
import { Encrypt_Value, Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import { globalColor, globalFont } from "../utils/RepeatFunctions/Schedule";
import axiosInstance from "../../axios/axios";
import { BsCheckCircle } from "react-icons/bs";
import {
  GetUserSearchData,
  SetUserSearchNoResult,
} from "../../StateManagement/Reducers/ScheduleState";
import { useDispatch } from "react-redux";
import moment from "moment";
import {
  Table,
  TableBody,
  TableBodyCell,
  TableHead,
  TableHeadCell,
  TableRow,
} from "../../StyledComponents";
import { Tablerow } from "./StyledComponent";
import edit_appointment from "../../assets/images/edit_appointment.png";
import delete_appointment from "../../assets/images/edit_appointment_delete.png";

const PatientGroupList = () => {
  const [spinner, setspinner] = useState(false);

  const [showGroupModal, setShowGroupModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [isPatientGroupPopup2Open, setIsPatientGroupPopup2Open] =
    useState(false);
  const [isPatientGroupPopup4Open, setIsPatientGroupPopup4Open] =
    useState(false);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (location?.state?.patientgroupstarted2) {
      setIsPatientGroupPopup2Open(true);
    }
    if (location?.state?.patientgroupstarted4) {
      setTimeout(() => {
        setIsPatientGroupPopup4Open(true);
      }, 400);
    }
  }, [
    location?.state?.patientgroupstarted2,
    location?.state?.patientgroupstarted4,
  ]);

  // const { RangePicker } = DatePicker;
  const [fromdt, setfrom] = useState("");
  const [todt, settodt] = useState("");

  const dispatch = useDispatch();

  const handleOpenGroupModal = () => setShowGroupModal(true);
  const handleCloseGroupModal = () => setShowGroupModal(false);

  const [usersearch, setUserSearch] = useState("");

  let storedNames = Decrypt_Value(localStorage.getItem("setroles"), "vozo");
  let authorized = Decrypt_Value(localStorage.getItem("authorized"), "vozo");
  let main_pro = Decrypt_Value(localStorage.getItem("main_pro"), "vozo");
  let owner_id = Decrypt_Value(localStorage.getItem("owner_id"), "vozo");
  let user_ID = Decrypt_Value(localStorage.getItem("user_id"), "vozo");

  const dtFormat = localStorage.getItem("dateFormat");
  const dateFormat = localStorage.getItem("dateFormat");

  const [usersid, setuserid] = useState("");
  const [mainRows, setMainRows] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [offVal, setOffVal] = useState(40);
  const [loadFlag, setLoadFlag] = useState(0);
  const [showLoading, setShowLoading] = useState("reportDivblock");
  const [groupList, setGroupList] = useState([]);
  const [groupSearch, setGroupSearch] = useState("");
  const [groupId, setGroupId] = useState("");
  const [groupNoResult, setGroupNoResult] = useState("1");
  const [groupLoading, setGroupLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const [status, setStatus] = useState("");

  const UserSearchDatas = useSelector((state) => state.Schedule.UserSearchData);
  const UserSearchNoResult = useSelector(
    (state) => state.Schedule.UserSearchNoResult,
  );

  const handleCreate = () => {
    setEditData(null);
    setShowGroupModal(true);
    if (isPatientGroupPopup2Open) {
      setIsPatientGroupPopup2Open(false);
      // Clean up state so it doesn't reopen on remount
      history.replace({
        pathname: location.pathname,
        state: {
          ...location.state,
          patientgroupstarted2: undefined,
          patientgroupstarted3: true,
        },
      });
    }
  };

  const handleEdit = (row) => {
    console.log(row);

    setEditData(row);
    setShowGroupModal(true);
  };

  // PROVIDER DROPDOWN
  const userdropdown = () => {
    let q =
      "limit=10&fname=" +
      usersearch +
      "&authorized=" +
      authorized +
      "&main_pro=" +
      main_pro +
      "&owner_id=" +
      owner_id +
      "&userID=" +
      user_ID +
      "&pat_share=" +
      storedNames.pat_g;

    dispatch(GetUserSearchData(q));
  };

  const groupDropdown = () => {
    setGroupLoading(true);
    let article =
      "limit=10&search=" +
      groupSearch +
      "&authorized=" +
      authorized +
      "&main_pro=" +
      main_pro +
      "&owner_id=" +
      owner_id +
      "&userID=" +
      user_ID;

    let enc = Encrypt_Value(article, "vozo");

    axiosInstance
      .get("vozo/patientgroup/search?search=" + enc)
      .then((res) => {
        const data = Decrypt_Value(res.data, "vozo") || [];
        setGroupList(data);
        setGroupLoading(false);
      })
      .catch(() => {
        setGroupList([]);
        setGroupLoading(false);
      });
  };

  const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const GroupSelect = (value) => {
    const [id, name] = value.split("-");
    setGroupId(id);
    setGroupSearch(name);
  };

  const fetchAllGroupNames = async () => {
    try {
      const payload = {
        limit: 1000, // enough to get all groups
      };

      const enc = Encrypt_Value(payload, "vozo");

      const res = await axiosInstance.put("vozo/patientgroup/list", enc);

      const data = Decrypt_Value(res.data, "vozo") || [];
      setGroupList(data);
    } catch (err) {
      console.error("Failed to fetch group names", err);
      setGroupList([]);
    }
  };
  useEffect(() => {
    fetchAllGroupNames();
  }, []);

  // fetch data

  useEffect(() => {
    firstLoadGroups();
  }, []);

  // const fetchGroupList = async () => {
  //   try {
  //     const res = await axiosInstance.get("/api/vozo/patientgroup/list");
  //     setGroupList(res.data || []);
  //   } catch (error) {
  //     console.error("Error fetching group list", error);
  //   }
  // };
  const firstLoadGroups = async () => {
    setspinner(true);

    const payload = {
      group_name: "",
      provider_id: usersid,
      status: "",
      fromDate: fromdt,
      toDate: todt,
      limit: 40,
      offset: 0,
    };

    const encrypted = Encrypt_Value(payload, "vozo");
    const rows = [];

    axiosInstance
      .put("vozo/patientgroup/list", encrypted)
      .then((res) => {
        const decrypted = Decrypt_Value(res.data, "vozo");
        // console.log(decrypted, "decrypted");

        decrypted.forEach((g) => rows.push(g));
        setMainRows(rows);

        // first 15 rows only
        setGroupData(decrypted.slice(0, 15));

        setShowLoading(
          decrypted.length > 15 ? "reportDivblock" : "reportDivnone",
        );

        setspinner(false);
      })
      .catch(() => {
        setGroupData([]);
        setspinner(false);
        setShowLoading("reportDivnone");
      });
  };

  // load more
  const loadMoreGroups = () => {
    setShowLoading("reportDivblock");

    let rowsCount = groupData.length;
    let finalRows = [...mainRows];

    if (finalRows.length === rowsCount) {
      setShowLoading("reportDivnone");
      return;
    }

    if (rowsCount >= offVal - 30 && loadFlag === 0) {
      setLoadFlag(1);
      setOffVal((v) => v + 40);

      const payload = {
        group_id: groupId || "",
        group_name: groupSearch || "",
        provider_id: usersid,
        status: "",
        fromDate: fromdt,
        toDate: todt,
        limit: 40,
        offset: offVal,
      };

      const encrypted = Encrypt_Value(payload, "vozo");

      axiosInstance
        .put("/api/vozo/patientgroup/list", encrypted)
        .then((res) => {
          const decrypted = Decrypt_Value(res.data, "vozo");
          setLoadFlag(0);
          setMainRows((prev) => [...prev, ...decrypted]);
        });
    }

    let items = [];
    let end = rowsCount + 10;

    for (let i = rowsCount; i < end; i++) {
      if (finalRows[i]) items.push(finalRows[i]);
    }

    setGroupData((prev) => [...prev, ...items]);
  };

  // onUpdate

  const onUpdate = () => {
    setOffVal(40);
    setLoadFlag(0);
    setspinner(true);

    const payload = {
      group_id: groupId || "",
      group_name: groupSearch || "",
      provider_id: usersid,
      status: status,
      // fromDate: fromdt,
      // toDate: todt,
      limit: 40,
      offset: 0,
    };

    if (!groupSearch) {
      payload.fromDate = fromdt;
      payload.toDate = todt;
    }

    // console.log("updatePayload", payload);

    const encrypted = Encrypt_Value(payload, "vozo");

    axiosInstance
      .put("vozo/patientgroup/list", encrypted)
      .then((res) => {
        const decrypted = Decrypt_Value(res.data, "vozo");

        setMainRows(decrypted);
        setGroupData(decrypted.slice(0, 15));

        setShowLoading(
          decrypted.length > 15 ? "reportDivblock" : "reportDivnone",
        );
        setspinner(false);
      })
      .catch(() => {
        setGroupData([]);
        setspinner(false);
      });
  };

  const fetchGroupList = async () => {
    try {
      const res = await axiosInstance.get("/api/vozo/patientgroup/list");
      setGroupList(res.data || []);
    } catch (error) {
      console.error("Error fetching group list", error);
    }
  };

  const handleDelete = (group_id) => {
    if (!window.confirm("Delete this patient group?")) return;

    axiosInstance
      .get(`vozo/patientgroup/delete?id=${group_id}`)
      .then(() => {
        setSuccessMsg("Patient Group deleted successfully");
        setShowSuccess(true);

        setGroupSearch("");
        setGroupId("");

        firstLoadGroups();
        fetchAllGroupNames();

        setTimeout(() => {
          setShowSuccess(false);
        }, 2000);
      })
      .catch(() => {
        setSuccessMsg("Failed to delete patient group");
        setShowSuccess(true);

        setTimeout(() => {
          setShowSuccess(false);
        }, 2000);
      });
  };

  useEffect(() => {
    let cancel = false;

    const handler = async () => {
      await new Promise((r) => setTimeout(r, 600));
      if (!cancel && usersearch !== "") {
        userdropdown(); // existing function
      }
    };

    handler();
    return () => (cancel = true);
  }, [usersearch]);

  const displayData =
    isPatientGroupPopup4Open && groupData.length === 0
      ? [
          {
            group_name: "Mental Health Counseling",
            group_id: "",
            status: "",
            patient_count: "",
            provider_name: "James Marry",
            start_date: "11-20-2025",
            end_date: "12-20-2025",
          },
        ]
      : groupData;

  return (
    <>
      {spinner ? (
        <Loader />
      ) : (
        <div>
          <>
            <div>
              <>
                <div
                  className="tab_title_main1"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <h1> Patient Group List</h1>

                  {isPatientGroupPopup2Open && (
                    <div
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.3)",
                        zIndex: 9999,
                      }}
                      onClick={() => {
                        setIsPatientGroupPopup2Open(false);
                        history.replace({
                          pathname: location.pathname,
                          state: {},
                        });
                      }}
                    />
                  )}

                  {isPatientGroupPopup4Open && (
                    <div
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "transparent",
                        zIndex: 9999,
                      }}
                      onClick={() => {
                        setIsPatientGroupPopup4Open(false);
                        history.replace({
                          pathname: location.pathname,
                          state: {},
                        });
                      }}
                    />
                  )}

                  <Popup
                    style={{ zIndex: 10001 }}
                    offset={[45, 5]}
                    content={
                      <GetStartedPopup
                        title="Add Patient Group"
                        description='To add a Patient Group, click on the "Create Patient Group" button.'
                        currentStep={2}
                        totalSteps={7}
                        onBack={() => {
                          setIsPatientGroupPopup2Open(false);
                          history.replace({
                            pathname: location.pathname,
                            state: { patientgroupstarted: true },
                          });
                        }}
                        onNext={() => {
                          setIsPatientGroupPopup2Open(false);
                          history.replace({
                            pathname: location.pathname,
                            state: { patientgroupstarted3: true },
                          });
                          handleOpenGroupModal();
                        }}
                        onClose={() => {
                          setIsPatientGroupPopup2Open(false);
                          history.replace({
                            pathname: location.pathname,
                            state: {},
                          });
                        }}
                        width="320px"
                      />
                    }
                    open={isPatientGroupPopup2Open}
                    position="left center"
                    trigger={
                      <div
                        style={
                          isPatientGroupPopup2Open
                            ? { zIndex: 10001, position: "relative" }
                            : {}
                        }
                      >
                        <Button
                          variant="primary"
                          className="save_active create-cli"
                          onClick={() => {
                            if (isPatientGroupPopup2Open) {
                              setIsPatientGroupPopup2Open(false);
                            }
                            handleOpenGroupModal();
                          }}
                          style={{
                            whiteSpace: "nowrap",
                            minWidth: "auto",
                            padding: "6px 16px",
                            width: "auto",
                            fontWeight: "600",
                            fontSize: "14px",
                            fontStyle: "semibold",
                          }}
                        >
                          Create Patient Group
                        </Button>
                      </div>
                    }
                  />
                </div>

                {/* filter */}

                <div className="backgr-chng for-eligibility-author">
                  <div className="eligibility-snd-layer rep-flex-align-center">
                    {/* patient Group search */}
                    <div className="for_autoComplete_bi ElligibiltyProductSearch">
                      <AiOutlineSearch />
                      <AutoComplete
                        virtual={false}
                        placeholder="Group Name"
                        className="remainderWidthSheet"
                        value={groupSearch}
                        onChange={(v) => {
                          setGroupSearch(v);
                          if (!v) setGroupId("");
                        }}
                        onSelect={GroupSelect}
                        options={groupList.map((g) => ({
                          label: g.group_name,
                          value: g.group_id + "-" + g.group_name,
                        }))}
                      />
                    </div>
                    {/* provider */}
                    <div className="for_autoComplete_bi ElligibiltyProductSearch">
                      <AiOutlineSearch />
                      <AutoComplete
                        virtual={false}
                        placeholder="Provider"
                        className="remainderWidthSheet"
                        value={usersearch}
                        onChange={(v) => {
                          setUserSearch(v);
                          dispatch(SetUserSearchNoResult("1"));
                          if (v === "") setuserid("");
                        }}
                        onSelect={(v) => {
                          const arr = v.split("-");
                          setUserSearch(arr[1]);
                          setuserid(arr[0]);
                        }}
                        onFocus={() => {
                          // Load providers when dropdown is clicked/focused
                          if (
                            usersearch === "" &&
                            UserSearchDatas.length === 0
                          ) {
                            userdropdown(); // This calls your existing userdropdown function
                          }
                        }}
                        notFoundContent={
                          UserSearchNoResult !== ""
                            ? "Loading..."
                            : "No Results Found"
                        }
                        options={UserSearchDatas.map((x) => ({
                          value: x.id + "-" + x.title,
                          label: x.title,
                        }))}
                      />
                    </div>

                    {/* status */}
                    <div className="tele-select-btn m-l-25  p-t-14">
                      <Select
                        placeholder="Status"
                        className="w-210 t-a-l antd-dd-tele_repo ant-sel-hei34 antd-dd-pay_anly"
                        value={status || undefined}
                        onChange={(value) => setStatus(value)}
                      >
                        <Select.Option value="Active">Active</Select.Option>
                        <Select.Option value="Inactive">Inactive</Select.Option>
                        <Select.Option value="Expired">Expired</Select.Option>
                      </Select>
                    </div>
                    {/* date */}
                    <div
                      id="rpt_pay-inp_dt"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginLeft: "25px",
                        marginTop: "12px",
                        flexShrink: 0,
                      }}
                    >
                      <span
                        style={{
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                        }}
                      >
                        From
                      </span>

                      <DatePicker
                        getPopupContainer={(triggerNode) =>
                          triggerNode.parentNode
                        }
                        value={fromdt ? moment(fromdt, "YYYY-MM-DD") : null}
                        format={dateFormat}
                        inputReadOnly
                        allowClear={false}
                        style={{ width: 140, minWidth: 140 }}
                        onChange={(date) => {
                          if (date) {
                            setfrom(moment(date).format("YYYY-MM-DD"));
                          }
                        }}
                      />

                      <span
                        style={{
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                        }}
                      >
                        To
                      </span>

                      <DatePicker
                        getPopupContainer={(triggerNode) =>
                          triggerNode.parentNode
                        }
                        value={todt ? moment(todt, "YYYY-MM-DD") : null}
                        format={dateFormat}
                        inputReadOnly
                        allowClear={false}
                        style={{ width: 140, minWidth: 140 }}
                        onChange={(date) => {
                          if (date) {
                            settodt(moment(date).format("YYYY-MM-DD"));
                          }
                        }}
                      />

                      {/* UPDATE BTN */}
                      <Button
                        variant="primary"
                        onClick={onUpdate}
                        style={{ marginLeft: "8px" }}
                      >
                        Update
                      </Button>
                    </div>
                  </div>
                </div>

                {/* TABLE */}
                <div className="appoint_report_card prior_rep_card_table">
                  <Card>
                    <div className="bill_summary_table">
                      <Table margin="20px 0px 0px 0px">
                        <TableHead
                          className="Tab_content_Table_Header appt-head "
                          display="table-header-group"
                          height="40px"
                        >
                          <TableRow
                            className="schedule-head-row tr-no"
                            fontWeight="400"
                            color={globalColor}
                          >
                            <TableHeadCell padding="20px 0px 20px 20px">
                              Group Name
                            </TableHeadCell>

                            <TableHeadCell>Group ID</TableHeadCell>

                            <TableHeadCell>Status</TableHeadCell>

                            <TableHeadCell>Patient #</TableHeadCell>

                            <TableHeadCell>Provider</TableHeadCell>

                            <TableHeadCell>Start Date</TableHeadCell>

                            <TableHeadCell>End Date</TableHeadCell>

                            <TableHeadCell paddingRight="20px">
                              Action
                            </TableHeadCell>
                          </TableRow>
                        </TableHead>

                        <TableBody className="tble-over appt_tab_alt1">
                          {displayData.length > 0 ? (
                            displayData.map((row, index) => {
                              const rowContent = (
                                <TableRow
                                  key={index}
                                  className="table-data-row schedule-body-row"
                                  fontFamily={globalFont}
                                  borderBottom="1px solid #cbd5e0"
                                  color="#636d73"
                                  height="56px"
                                  style={
                                    isPatientGroupPopup4Open && index === 0
                                      ? {
                                          zIndex: 10001,
                                          position: "relative",
                                          backgroundColor: "#fff",
                                        }
                                      : {}
                                  }
                                >
                                  <TableBodyCell padding="14px 0px 14px 20px">
                                    <span title={row.group_name}>
                                      {row.group_name.length > 15
                                        ? row.group_name.slice(0, 15) + "..."
                                        : row.group_name}
                                    </span>
                                  </TableBodyCell>

                                  <TableBodyCell content="center">
                                    {row.group_id}
                                  </TableBodyCell>

                                  <TableBodyCell>{row.status}</TableBodyCell>

                                  <TableBodyCell content="right">
                                    {row.patient_count}
                                  </TableBodyCell>

                                  <TableBodyCell>
                                    {isPatientGroupPopup4Open && index === 0 ? (
                                      <Popup
                                        open={isPatientGroupPopup4Open}
                                        position="left center"
                                        offset={[35, 40]}
                                        style={{ zIndex: 10001 }}
                                        content={
                                          <GetStartedPopup
                                            title="Add Patient Group"
                                            description="View the added patient group in the Patient Group list"
                                            currentStep={4}
                                            totalSteps={7}
                                            onBack={() => {
                                              setIsPatientGroupPopup4Open(
                                                false,
                                              );
                                              history.replace({
                                                pathname: location.pathname,
                                                state: {
                                                  patientgroupstarted3: true,
                                                },
                                              });
                                              handleOpenGroupModal();
                                            }}
                                            onNext={() => {
                                              setIsPatientGroupPopup4Open(
                                                false,
                                              );
                                              history.push(
                                                "/schedule/calender",
                                                {
                                                  patientgroupstarted5: true,
                                                },
                                              );
                                            }}
                                            onClose={() => {
                                              setIsPatientGroupPopup4Open(
                                                false,
                                              );
                                              history.replace({
                                                pathname: location.pathname,
                                                state: {},
                                              });
                                            }}
                                            width="320px"
                                          />
                                        }
                                        trigger={
                                          <span title={row.provider_name}>
                                            {row.provider_name.length > 15
                                              ? row.provider_name.slice(0, 15) +
                                                "..."
                                              : row.provider_name}
                                          </span>
                                        }
                                      />
                                    ) : (
                                      <span title={row.provider_name}>
                                        {row.provider_name?.length > 15
                                          ? row.provider_name.slice(0, 15) +
                                            "..."
                                          : row.provider_name}
                                      </span>
                                    )}
                                  </TableBodyCell>

                                  <TableBodyCell>
                                    {row.start_date
                                      ? moment(row.start_date).format(
                                          dateFormat,
                                        )
                                      : ""}
                                  </TableBodyCell>

                                  <TableBodyCell>
                                    {row.end_date
                                      ? moment(row.end_date).format(dateFormat)
                                      : ""}
                                  </TableBodyCell>

                                  <TableBodyCell
                                    style={{ display: "flex", gap: "10px" }}
                                  >
                                    <img
                                      src={edit_appointment}
                                      alt="edit"
                                      onClick={() => handleEdit(row)}
                                      style={{ cursor: "pointer" }}
                                    />
                                    <img
                                      src={delete_appointment}
                                      alt="delete"
                                      onClick={() => handleDelete(row.group_id)}
                                      style={{ cursor: "pointer" }}
                                    />
                                  </TableBodyCell>
                                </TableRow>
                              );

                              return rowContent;
                            })
                          ) : (
                            <React.Fragment>
                              {isPatientGroupPopup4Open ? (
                                <Popup
                                  open={true}
                                  position="bottom center"
                                  offset={[0, 10]}
                                  style={{ zIndex: 10001 }}
                                  content={
                                    <GetStartedPopup
                                      title="Add Patient Group"
                                      description="View the added patient group in the Patient Group list"
                                      currentStep={4}
                                      totalSteps={7}
                                      onBack={() => {
                                        setIsPatientGroupPopup4Open(false);
                                        history.replace({
                                          pathname: location.pathname,
                                          state: { patientgroupstarted3: true },
                                        });
                                        handleOpenGroupModal();
                                      }}
                                      onGotIt={() => {
                                        setIsPatientGroupPopup4Open(false);
                                        history.replace({
                                          pathname: location.pathname,
                                          state: { patientgroupstarted5: true },
                                        });
                                      }}
                                      onClose={() => {
                                        setIsPatientGroupPopup4Open(false);
                                        history.replace({
                                          pathname: location.pathname,
                                          state: {},
                                        });
                                      }}
                                      width="320px"
                                    />
                                  }
                                  trigger={
                                    <Tablerow
                                      className="bot_border"
                                      style={{
                                        zIndex: 10001,
                                        position: "relative",
                                        backgroundColor: "#fff",
                                      }}
                                    >
                                      <TableBodyCell
                                        className="appCellCenter patpor_main_div"
                                        colSpan={8}
                                      >
                                        <div className="img_top">
                                          <Image
                                            height="133px"
                                            width="133px"
                                            src={Emp_data_pic}
                                          ></Image>
                                        </div>
                                      </TableBodyCell>
                                    </Tablerow>
                                  }
                                />
                              ) : (
                                <Tablerow className="bot_border">
                                  <TableBodyCell
                                    className="appCellCenter patpor_main_div"
                                    colSpan={8}
                                  >
                                    <div className="img_top">
                                      <Image
                                        height="133px"
                                        width="133px"
                                        src={Emp_data_pic}
                                      ></Image>
                                    </div>
                                  </TableBodyCell>
                                </Tablerow>
                              )}
                            </React.Fragment>
                          )}
                        </TableBody>
                      </Table>
                      {groupData.length !== 0 && (
                        <div className={"loading-more " + showLoading}>
                          <Button variant="primary" onClick={loadMoreGroups}>
                            Load more...
                          </Button>
                        </div>
                      )}
                    </div>
                  </Card>
                </div>
              </>
            </div>
          </>
        </div>
      )}
      <Modal
        className="client-popup create-client create_modaltop wid_562"
        centered
        show={showGroupModal}
        onHide={() => {
          setShowGroupModal(false);
          setEditData(null);
        }}
      >
        <CreateGroupClients
          onClose={() => {
            setShowGroupModal(false);
            setEditData(null);
          }}
          editData={editData}
          onSuccess={(msg) => {
            setShowGroupModal(false);
            setEditData(null);
            setSuccessMsg(msg);
            setShowSuccess(true);
            firstLoadGroups();
            fetchAllGroupNames();
            setTimeout(() => {
              setShowSuccess(false);
            }, 2000);
          }}
        />
      </Modal>
      <Modal
        className="alert-popup-message"
        show={showSuccess}
        onHide={() => setShowSuccess(false)}
        onExited={() => setSuccessMsg("")}
        backdrop={false}
      >
        <div className="alert msg alert-success" role="alert">
          <BsCheckCircle className="icons-bs" />
          {successMsg}
        </div>
      </Modal>
    </>
  );
};

export default PatientGroupList;
